<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import Alert from '@/components/Elements/Alerts/Alert.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { handleNext } from '../tutorialSteps'
import { usePlayerFlagsStore } from '@/stores/playerFlagsStore.ts'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'

const playerFlagsStore = usePlayerFlagsStore()

const handleNextStep = async () => {
  await handleNext('tutorial_resources_end')
  await playerFlagsStore.setFlag('tutorial_complete', 'true')
}
</script>

<template>
  <TutorialFrame 
    video-url="https://cdn.ferion.com/videos/advisors/temperate/resources.webm"
  >
    <template #text>
      <p class="pb-2">
        Excellent! You've mastered the fundamentals of resource management!
      </p>
      <p class="pb-2">
        <strong>Remember the key principles:</strong><br>
        • Planets generate ore<br>
        • Trade surplus for needed ores/materials<br>
        • Plan refineries based on future projects<br>
        • Monitor your resource flow regularly
      </p>
      <p class="pb-2">
        A strong economy is the foundation of a powerful empire. Keep your resources flowing, your refineries efficient, and your storage adequate.
      </p>
    </template>

    <template #alerts>
    </template>

    <template #buttons>
      <ActionButton @click="handleNextStep">
        Thank You!
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss">

</style>